module.exports = __webpack_public_path__ + "media/images/cats/purina-one-healthy-kitten-food.png";